import PropTypes from 'prop-types';
import isMobile from 'is-mobile';

function IfMobile({ shouldRenderMobile, thenRender, elseRender, props }) {
  return shouldRenderMobile ? thenRender(props) : elseRender(props);
}

IfMobile.defaultProps = {
  shouldRenderMobile: isMobile()
};

IfMobile.propTypes = {
  shouldRenderMobile: PropTypes.bool,
  thenRender: PropTypes.func.isRequired,
  elseRender: PropTypes.func.isRequired,
  props: PropTypes.object
};

export default IfMobile;
